import { Button, Form, Input, InputNumber } from 'antd';
import { formItemLayout, tailFormItemLayout } from 'utils/formConfig';

const ItemForm = ({ form, submiting, onFinish, initialValues, name }) => {
  return (
    <Form
      {...formItemLayout}
      form={form}
      name={name || 'province_form'}
      onFinish={values => onFinish(values)}
      initialValues={initialValues}
      scrollToFirstError
    >
      <Form.Item name="name" label="Name">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="fmarket_id" label="FMarket ID">
        <InputNumber placeholder="" />
      </Form.Item>

      <Form.Item {...tailFormItemLayout}>
        <Button type="primary" htmlType="submit" loading={submiting}>
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ItemForm;
